import { styled } from '../../lib/stitches'

/**
 * A base flex component
 * Defaults to flex row with no other styles
 */
export const Flex = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  variants: {
    direction: {
      row: {
        flexDirection: 'row'
      },
      column: {
        flexDirection: 'column'
      }
    },
    width: {
      full: {
        width: '100%'
      }
    }
  }
})
